import axios from "@/app/Axios";
//import routerProtected from "@/app/routerProtected";

class PersonalMilitarService {

  async index() {
    try {
      const response = await axios.get("/getpersonalmilitarcomplete");
      return response.data;
    } catch (error) {
      console.log(error);
      return error.response.data;
    }
  }
  async indexcount() {
    try {
      const response = await axios.get("/getpersonalpolicialcount");
      return response.data;
    } catch (error) {
      console.log(error);
      return error.response.data;
    }
  }

  async store(personalPolicial) {
    try {
      const response = await axios.post("/postpersonalmilitarcomplete", personalPolicial);
      return response.data;
    } catch (error) {
      console.log(error);
      return error.response.data;
    }
  }

  async destroypolicia(id_registro) {
    try {
        const response = await axios.delete(`/deletepersonalmilitarcomplete/${id_registro}`);
        return response.data;
    } catch (error) {
      console.error("Error al eliminar el registro:", error);
        if (error.response && error.response.status === 401) {
            return error.response.data;
        } else {
            console.log(error);
        }
    }
}
async updateForm(id, datosPoli) {
  try {
    const response = await axios.put(`/putpersonalmilitarcomplete/${id}`, datosPoli);
    console.log("Respuesta del servidor:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error al actualizar el formulario:", error);
    throw error;
  }
}
  async update() {
    const id_registro = this.getFill().id;

    try {
      const response = await axios.put(`/putpersonalmilitarcomplete/${id_registro}`, this.getFill());
      return response.data;
    } catch (error) {
      console.error("Error al actualizar el registro:", error);
      return error.response.data;
    }
  }
  async importRecords(is_archivo_xlsx) {
    try {
        const resolve = await axios.post("/carga-masiva-complete", {
            archivo_xlsx: is_archivo_xlsx,
            sucursal: this.sucursal
        }, {
            headers: {
                'Assept': 'Application/json',
                'Content-Type': 'multipart/form-data'
            }
        });
        return resolve.data;
    } catch (error) {
        return error.response.data;
    }

}
}

export default PersonalMilitarService;
